export default "__VITE_ASSET__DuKwNnky__"